import * as request from 'superagent';
import appSettings from '../appSettings';

function baseUrl(r: request.SuperAgentRequest) {
    if (r.url[0] === '/') {
        r.url = appSettings.BASE_API_URL + r.url;
    }
    return r;
}

function addAuthHeaders(r: request.SuperAgentRequest) {
    if (!!appSettings.REACT_APP_ROOT_URL) {
        for (var key in appSettings.REACT_APP_API_HEADERS) {
            r.set(key, appSettings.REACT_APP_API_HEADERS[key]);
        }
    }

    return r;
}

function handleResponse(r: request.Response) {
    if (!!r.error) {
        throw { errorMessgae: "Network error. Try again later, please" };
    }
    if (r.badRequest) {
        var error = JSON.parse(r.xhr.getResponseHeader('x-cub-hdr') || "{}");
        throw error;
    }
    return r.body;
}

function handlerError(err: any) {
    if (err.status >= 400 && err.status <= 500) {
        throw JSON.parse(err.response.xhr.getResponseHeader('x-cub-hdr') || "{}");
    } else {
        throw { errorMessage: "Error occured. Try again later, please." };
    }
}

export class ApiService {
    public get(url: string) {
        return request.get(url)
            .use(baseUrl)
            .use(addAuthHeaders)
            .catch(handlerError)
            .then(handleResponse);
    }

    public post(url: string, data?: any) {
        return request.post(url)
            .use(baseUrl)
            .use(addAuthHeaders)
            .send(data)
            .catch(handlerError)
            .then(handleResponse);
    }
}


// WEBPACK FOOTER //
// ./src/services/apiService.ts